import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import { Avatar } from '@material-ui/core';
import { format, parseISO, differenceInYears } from 'date-fns';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { errorMessage } from '~/utils/Message';
import Backdrop from '~/components/BackdropComponent';

import api from '~/services/api';

import { Container, Content, Header, Section, Line, Text } from './styles';

const useStyles = makeStyles((theme) => ({
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  large: {
    width: theme.spacing(12),
    height: theme.spacing(12),
  },
}));

function MoreInformation({ user }) {
  const classes = useStyles();

  const [profile, setProfile] = useState(user);
  const [loading, setLoading] = useState(false);

  const {
    id,
    name,
    avatar,
    register,
    phone,
    address,
    hemocenter,
    birth,
    createdAt,
    updatedAt,
  } = profile;

  const ageParsed = differenceInYears(new Date(), parseISO(birth));
  const birthParsed = birth && format(parseISO(birth), 'dd/MM/yyyy');
  const createdAtParsed =
    createdAt && format(parseISO(createdAt), "dd 'de' MMMM yyyy, 'às' p");
  const updatedAtParsed =
    updatedAt && format(parseISO(updatedAt), "dd 'de' MMMM yyyy, 'às' p");

  const loadUser = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/users/${id}`);

      setProfile(data);
    } catch (error) {
      errorMessage(error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  return (
    <Container>
      <Header>
        {avatar ? (
          <Avatar className={classes.large} alt={name} src={avatar.url} />
        ) : (
          <Avatar className={classes.large}>
            {name && name.charAt(0).toUpperCase()}
          </Avatar>
        )}

        <p>{name}</p>
        {birth && <span>{ageParsed} anos</span>}
      </Header>

      <Content>
        <Section>Dados pessoais</Section>
        <Text bold>
          Nome: <Text>{name}</Text>
        </Text>

        <Text bold>
          N.º de registro: <Text>{register}</Text>
        </Text>

        <Text bold>
          Endereço: <Text>{address}</Text>
        </Text>

        <Text bold>
          Data de nascimento: <Text>{birthParsed}</Text>
        </Text>

        <Text bold>
          Hemocentro: <Text>{hemocenter && hemocenter.alias}</Text>
        </Text>

        <Line />
        <Section>Contato</Section>

        <Text bold>
          Telefone: <Text>{phone}</Text>
        </Text>

        <Line />
        <Section>Outras informações</Section>

        <Text bold>
          Registro criado em: <Text>{createdAtParsed}</Text>
        </Text>

        <Text bold>
          Registro atualizado em: <Text>{updatedAtParsed}</Text>
        </Text>
      </Content>

      <Backdrop open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
}

MoreInformation.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    register: PropTypes.number,
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
  }).isRequired,
};

export default MoreInformation;
